import React from "react";
import moment from "moment-timezone";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { HOURS_12_FORMAT_WITH_DATE } from "../../../../constants";
import DeleteNote from "./DeleteNote";
import { IDbWatchlistNotes } from "../../../../api/dbModelsInterfaces";

type TWatchlistNotesColumns = (args: {
  withCustomerDataColumns?: boolean;
  onEditNote: (ids: number[]) => void;
}) => Array<IColum>;

export const getWatchlistNotesColumns: TWatchlistNotesColumns = ({
  onEditNote,
  withCustomerDataColumns,
}) => {
  return [
    {
      by: "delete",
      title: "",
      path: "ids",
      getCellValue: (ids, restValues): React.ReactElement => {
        const id = (restValues as IDbWatchlistNotes).id;
        const selectedIds = [...(ids as unknown as number[]), ...(id ? [id] : [])];
        return (
          <div style={{ display: "flex" }}>
            <IconButton onClick={() => onEditNote(selectedIds)} size="small">
              <EditIcon cursor="pointer" />
            </IconButton>
            <DeleteNote ids={selectedIds} />
          </div>
        );
      },
    },
    {
      by: "measure_timestamp",
      title: "Measure timestamp",
      path: "measure_timestamp",
      getCellValue: (measure_timestamp): React.ReactElement => {
        return (
          <>
            {moment(measure_timestamp as unknown as string)
              //.tz("America/Chicago")
              .format(HOURS_12_FORMAT_WITH_DATE)}
          </>
        );
      },
      copyToClipBoardCallBack: (measure_timestamp): string => {
        return moment(measure_timestamp as string)
          .tz("America/Chicago")
          .format(HOURS_12_FORMAT_WITH_DATE);
      },
    },
    {
      by: "reason",
      title: "Reason",
      path: "reason",
    },
    {
      by: "measure_taken",
      title: "Measure taken",
      path: "measure_taken",
    },
    ...(withCustomerDataColumns
      ? [
          {
            by: "account",
            title: "Name",
            path: "account.name",
          },
          {
            by: "email",
            title: "Email",
            path: "account.email",
          },
        ]
      : []),
  ];
};
